import { getPhaseConfigConstants, updatePhaseConfigConstants } from '../constants/phasesConstants';

const { createFetchStandartFlowActionCreators } = require('../../utils/helpers/actionCreatorHelpers');

// eslint-disable-next-line max-len
export const getPhaseConfigActionCreators = createFetchStandartFlowActionCreators(getPhaseConfigConstants);
// eslint-disable-next-line max-len
export const updatePhaseConfigActionCreators = createFetchStandartFlowActionCreators(updatePhaseConfigConstants);
